/* eslint-disable no-template-curly-in-string */
export const DEFAULT_LIQUID: string[] = [
  '{{${first_name}}}',
  '{{${last_name}}}',
  '{{${email_address}}}',
  '{{${language}}}',
  '{{${country}}}',
  '{{${user_id}}}',
  '{{${most_recent_location}}}',
  '{{${date_of_birth}}}',
  '{{${phone_number}}}',
  '{{${gender}}}',
  '{{${city}}}',
  '{{${last_used_app_date}}}',
  '{{${most_recent_app_version}}}',
  '{{${time_zone}}}',
  '{{${most_recent_locale}}}',
  '{{${braze_id}}}',
  '{{${random_bucket_number}}}'
];
